import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import messages from '../../../test/messages'

// const initialState = messages

const initialState = []


export default function appReducer(state = initialState, action) {
  // console.log("message action", action)
  switch (action.type) {

    case types.ADD_MESSAGE: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_MESSAGE: {
      return [...state.map(message => message.id == action.payload.id ? (action.payload) : ({ ...message }))]

    }

    case types.DELETE_MESSAGE: {
      return state.filter(message => message.id !== action.payload.id)
    }

    case types.UPDATE_FULL_MESSAGES: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_MESSAGES: {
      return [
        ...action.payload
      ]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}